/**
 * React Query hook for completing inspection review
 */
import { toast } from 'react-hot-toast';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { translate } from '@utils/i18n';
import { IIM_REVIEW_COMPLETED_EVENT } from '@features/IIMReview';
import InspectionsReviewService from '../services/InspectionsReviewService';
const namespace = 'features.ai_to_review_inspections.index';
/**
 * Hook for completing inspection review with optimistic updates
 * @returns Mutation object for completing inspection review
 */
export default function useCompleteReview() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (params) => InspectionsReviewService.completeReview(params),
        // On successful completion, invalidate the inspections list to refetch updated data
        onSuccess: () => {
            // Invalidate the main inspections review query to refetch the list
            void queryClient.invalidateQueries({ queryKey: ['ai-review-inspections'] });
            // Signal the IIM Review feature (mounted in a separate React tree on the
            // inspection page) so it can flip its mode to ReadOnly without a full page reload.
            document.dispatchEvent(new CustomEvent(IIM_REVIEW_COMPLETED_EVENT));
            toast.success(translate('review_completed_successfully', { namespace }));
        },
        onError: (error) => {
            console.error('Error completing review:', error);
            toast.error(translate('error_completing_review', { namespace }));
        }
    });
}
